module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9lF1Y"))).then(() => parcelRequire('f4eak'));